module.exports = __webpack_public_path__ + "img/1.ae725091.png";